import React, { FunctionComponent, useState } from 'react';
import styles from './ModalComponent.module.scss';
import { useHistory } from 'react-router-dom';
import { _t } from 'app/utils/i18n';
import { CountDownLoader } from '../CountDownLoader/CountDownLoader';

import { getSearchState } from 'app/utils/search-state';

interface Props {
  hideOnCancel?: boolean;
  onOk?: any;
  onCanCel?: any;
  message: string;
  onOkText?: string;
  onCancelText?: string;
  handleresyncHashtag?: any;
  setSecondOPenModal?: any;
  hideOnOk?: boolean;
  withLoader?: boolean;
  isComplete?: any;
  statusRefetch?: any;
  isInfluencerModule?: any;
  handleresyncInfluencer?: any;
  videoModule?: boolean;
  fullScreen?: boolean;
  goBackOnCancel?: boolean;
  goBackLink?: boolean;
  onCancelHide?: boolean;
}
export const ModalComponent: FunctionComponent<Props> = ({
  onOk,
  onOkText,
  onCancelText,
  goBackOnCancel,
  message,
  handleresyncHashtag,
  setSecondOPenModal,
  hideOnOk,
  withLoader,
  isComplete,
  statusRefetch,
  isInfluencerModule,
  handleresyncInfluencer,
  hideOnCancel,
  videoModule,
  fullScreen,
  goBackLink,
  onCancelHide,
}) => {
  const [isHide, setIsHide] = useState(false);
  const history = useHistory();
  return (
    <div
      className={`${isHide ? styles.Close : styles.ModalComponent} ${
        fullScreen && styles.fullScreen
      }`}
      data-testid="modalComponentContainer"
    >
      <div className={styles.ModalComponent__Box}>
        <div className={styles.ModalComponent__Box__Message} dir="auto">
          {message}
        </div>
        {withLoader && (
          <CountDownLoader
            timeStartMilliseconds={120000}
            isComplete={isComplete || isHide}
            checkStatus={statusRefetch}
            moduleName={'modal'}
          />
        )}
        <div className={styles.ModalComponent__Box__Buttons}>
          {!hideOnOk && (
            <button
              className="main-btn"
              onClick={() => {
                onOk
                  ? onOk()
                  : isInfluencerModule
                    ? handleresyncInfluencer()
                    : !videoModule && handleresyncHashtag();
                !videoModule && !onOk && setSecondOPenModal(true);
                setIsHide(true);
              }}
            >
              {onOkText || _t('basic:yes')}
            </button>
          )}
          {!hideOnCancel && (
            <button
              className={hideOnOk ? styles.cancel : ''}
              onClick={() => {
                // onCancel;
                if (goBackOnCancel) {
                  history.goBack();
                  setIsHide(true);
                  return undefined;
                }
                if (onCancelHide) {
                  setIsHide(true);
                  return undefined;
                }
                history.action === 'POP'
                  ? history.push(getSearchState(''))
                  : history.goBack();
                setIsHide(true);
              }}
            >
              {onCancelText || _t('basic:no')}
            </button>
          )}
        </div>
        {goBackLink ? (
          <a
            className={styles.ModalComponent__Box__Link}
            onClick={() => {
              history.goBack();
              setIsHide(true);
            }}
          >
            {_t('basic:go_back')}
          </a>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
